/**
 * @ngdoc object
 * @name eventix.common.services.Locales
 * @description
 * Global array of available locales for events, also functions as a storage
 * facility to persist language settings across sessions.
 *
 * <pre>
 * [{label: 'Nederland', code: 'nl_NL'}]
 * </pre>
 */
export default angular.module('eventix.common.services.locales', [])
    .provider('Locales', function() {
        const provider = this;
        const Locales = [{
            label: 'Great Britain',
            translation: true,
            moment: 'en-gb',
            code: 'en_GB'
        }, {
            label: 'United States',
            translation: false,
            moment: 'en',
            code: 'en_US'
        }, {
            label: 'België',
            translation: false,
            moment: 'nl-be',
            code: 'nl_BE'
        }, {
            label: 'Nederland',
            translation: true,
            moment: 'nl',
            code: 'nl_NL'
        }, {
            label: 'Italiano',
            translation: true,
            moment: 'it',
            code: 'it_IT'
        }, {
            label: 'France',
            translation: true,
            moment: 'fr',
            code: 'fr_FR'
        }, {
            label: '中文',
            translation: true,
            moment: 'zh-cn',
            code: 'zh_CN'
        }, {
            label: 'Deutsch',
            translation: true,
            moment: 'de',
            code: 'de_DE'
        }, {
            label: 'España',
            translation: true,
            moment: 'es',
            code: 'es_ES'
        }, {
            label: 'Australia',
            translation: false,
            moment: 'en',
            code: 'en_AU'
        }, {
            label: 'Turkish',
            translation: true,
            moment: 'tr',
            code: 'tr_TR'
        }];

        provider.available = _.map(Locales, 'code');
        provider.mapping = {};
        _.forEach(_.filter(Locales, {translation: true}), locale => {
            let newCode = locale.code.slice(0, 2) + '_*';
            provider.mapping[newCode] = locale.code;
        });
        provider.mapping['*'] = 'en_GB';
        provider.$get = /*@ngInject*/function(store) {
            _.forEach(Locales, l => {
                l.icon = 'flag-icon flag-icon-' + l.code.slice(-2).toLowerCase();
            });
            var selected = store.get('NG_TRANSLATE_LANG_KEY');
            if (selected) {
                moment.locale(_.get(_.find(Locales, {code: selected}), 'moment', 'en'));
            }

            Object.defineProperties(Locales, {
                /**
                 * @ngdoc property
                 * @name eventix.common.services.Locales#selected
                 * @propertyOf eventix.common.services.Locales
                 * @description
                 * Locale setting
                 */
                selected: {
                    get: () => selected,
                    set: l => {
                        if (_.isString(l)) {
                            moment.locale(_.get(_.find(Locales, {code: l}), 'moment', 'en'));
                        }
                        return selected = l;
                    },
                    enumerable: false
                },
                /**
                 * @ngdoc method
                 * @name eventix.common.services.Locales#put
                 * @methodOf eventix.common.services.Locales
                 * @description
                 * Save a language setting
                 *
                 * @example
                 * <pre>
                 * Locales.put('NL_TRANSLATE_LANG_KEY','nl_NL');
                 * </pre>
                 *
                 * @param {String} name The setting to save
                 * @param {String} value The value to save
                 */
                put: {
                    value: function(name, value) {
                        if (name === 'NG_TRANSLATE_LANG_KEY') {
                            this.selected = value;
                        }
                        return store.set(name, value);
                    },
                    enumerable: false
                },
                /**
                 * @ngdoc method
                 * @name eventix.common.services.Locales#get
                 * @methodOf eventix.common.services.Locales
                 * @description
                 * Fetch a language setting
                 *
                 * @example
                 * <pre>
                 * Locales.get('NL_TRANSLATE_LANG_KEY');
                 * </pre>
                 *
                 * @param {String} name The setting to fetch
                 * @returns {String} The value stored at `name`
                 */
                get: {
                    value: function(name) {
                        var value = store.get(name);
                        if (name === 'NG_TRANSLATE_LANG_KEY') {
                            this.selected = value;
                        }
                        return value;
                    },
                    enumerable: false
                },

                /**
                 * @ngdoc property
                 * @name eventix.common.services.Locales#countries
                 * @propertyOf eventix.common.services.Locales
                 * @description
                 * Coutry list
                 */
                countries: {
                    value: {
                        'AF': {
                            display_name: 'Afghanistan',
                            code: 'AF',
                            locales: ['ps_AF', 'ps_AF']
                        },
                        'AX': {
                            display_name: '\u00c5land Islands',
                            code: 'AX',
                            locales: []
                        },
                        'AL': {
                            display_name: 'Albania',
                            code: 'AL',
                            locales: ['sq_AL']
                        },
                        'DZ': {
                            display_name: 'Algeria',
                            code: 'DZ',
                            locales: ['ar_DZ', 'ar_DZ']
                        },
                        'AS': {
                            display_name: 'American Samoa',
                            code: 'AS',
                            locales: []
                        },
                        'AD': {
                            display_name: 'Andorra',
                            code: 'AD',
                            locales: ['ca_AD']
                        },
                        'AO': {
                            display_name: 'Angola',
                            code: 'AO',
                            locales: []
                        },
                        'AI': {
                            display_name: 'Anguilla',
                            code: 'AI',
                            locales: []
                        },
                        'AQ': {
                            display_name: 'Antarctica',
                            code: 'AQ',
                            locales: []
                        },
                        'AG': {
                            display_name: 'Antigua & Barbuda',
                            code: 'AG',
                            locales: ['en_AG', 'en_AG']
                        },
                        'AR': {
                            display_name: 'Argentina',
                            code: 'AR',
                            locales: ['es_AR', 'es_AR']
                        },
                        'AM': {
                            display_name: 'Armenia',
                            code: 'AM',
                            locales: ['hy_AM', 'hy_AM']
                        },
                        'AW': {
                            display_name: 'Aruba',
                            code: 'AW',
                            locales: ['nl_AW', 'nl_AW']
                        },
                        'AU': {
                            display_name: 'Australia',
                            code: 'AU',
                            locales: ['en_AU', 'en_AU']
                        },
                        'AT': {
                            display_name: 'Austria',
                            code: 'AT',
                            locales: ['de_AT', 'de_AT', 'de_AT']
                        },
                        'AZ': {
                            display_name: 'Azerbaijan',
                            code: 'AZ',
                            locales: ['az_AZ', 'az_AZ']
                        },
                        'BS': {
                            display_name: 'Bahamas',
                            code: 'BS',
                            locales: []
                        },
                        'BH': {
                            display_name: 'Bahrain',
                            code: 'BH',
                            locales: ['ar_BH', 'ar_BH']
                        },
                        'BD': {
                            display_name: 'Bangladesh',
                            code: 'BD',
                            locales: ['bn_BD', 'bn_BD']
                        },
                        'BB': {
                            display_name: 'Barbados',
                            code: 'BB',
                            locales: []
                        },
                        'BY': {
                            display_name: 'Belarus',
                            code: 'BY',
                            locales: ['be_BY', 'be_BY']
                        },
                        'BE': {
                            display_name: 'Belgium',
                            code: 'BE',
                            locales: ['de_BE', 'de_BE', 'de_BE', 'fr_BE', 'fr_BE', 'fr_BE', 'li_BE', 'li_BE', 'nl_BE', 'nl_BE', 'wa_BE']
                        },
                        'BZ': {
                            display_name: 'Belize',
                            code: 'BZ',
                            locales: []
                        },
                        'BJ': {
                            display_name: 'Benin',
                            code: 'BJ',
                            locales: []
                        },
                        'BM': {
                            display_name: 'Bermuda',
                            code: 'BM',
                            locales: []
                        },
                        'BT': {
                            display_name: 'Bhutan',
                            code: 'BT',
                            locales: ['dz_BT', 'dz_BT']
                        },
                        'BO': {
                            display_name: 'Bolivia',
                            code: 'BO',
                            locales: ['es_BO', 'es_BO']
                        },
                        'BA': {
                            display_name: 'Bosnia',
                            code: 'BA',
                            locales: ['bs_BA']
                        },
                        'BW': {
                            display_name: 'Botswana',
                            code: 'BW',
                            locales: ['en_BW', 'en_BW']
                        },
                        'BV': {
                            display_name: 'Bouvet Island',
                            code: 'BV',
                            locales: []
                        },
                        'BR': {
                            display_name: 'Brazil',
                            code: 'BR',
                            locales: ['pt_BR', 'pt_BR']
                        },
                        'IO': {
                            display_name: 'British Indian Ocean Territory',
                            code: 'IO',
                            locales: []
                        },
                        'VG': {
                            display_name: 'British Virgin Islands',
                            code: 'VG',
                            locales: []
                        },
                        'BN': {
                            display_name: 'Brunei',
                            code: 'BN',
                            locales: []
                        },
                        'BG': {
                            display_name: 'Bulgaria',
                            code: 'BG',
                            locales: ['bg_BG']
                        },
                        'BF': {
                            display_name: 'Burkina Faso',
                            code: 'BF',
                            locales: []
                        },
                        'BI': {
                            display_name: 'Burundi',
                            code: 'BI',
                            locales: []
                        },
                        'KH': {
                            display_name: 'Cambodia',
                            code: 'KH',
                            locales: ['km_KH', 'km_KH']
                        },
                        'CM': {
                            display_name: 'Cameroon',
                            code: 'CM',
                            locales: []
                        },
                        'CA': {
                            display_name: 'Canada',
                            code: 'CA',
                            locales: ['en_CA', 'en_CA', 'fr_CA', 'fr_CA', 'fr_CA', 'ik_CA', 'ik_CA', 'iu_CA', 'iu_CA']
                        },
                        'CV': {
                            display_name: 'Cape Verde',
                            code: 'CV',
                            locales: []
                        },
                        'BQ': {
                            display_name: 'Caribbean Netherlands',
                            code: 'BQ',
                            locales: []
                        },
                        'KY': {
                            display_name: 'Cayman Islands',
                            code: 'KY',
                            locales: []
                        },
                        'CF': {
                            display_name: 'Central African Republic',
                            code: 'CF',
                            locales: []
                        },
                        'TD': {
                            display_name: 'Chad',
                            code: 'TD',
                            locales: []
                        },
                        'CL': {
                            display_name: 'Chile',
                            code: 'CL',
                            locales: ['es_CL', 'es_CL']
                        },
                        'CN': {
                            display_name: 'China',
                            code: 'CN',
                            locales: ['bo_CN', 'bo_CN', 'ug_CN', 'ug_CN', 'ug_CN', 'zh_CN', 'zh_CN']
                        },
                        'CX': {
                            display_name: 'Christmas Island',
                            code: 'CX',
                            locales: []
                        },
                        'CC': {
                            display_name: 'Cocos (Keeling) Islands',
                            code: 'CC',
                            locales: []
                        },
                        'CO': {
                            display_name: 'Colombia',
                            code: 'CO',
                            locales: ['es_CO', 'es_CO']
                        },
                        'KM': {
                            display_name: 'Comoros',
                            code: 'KM',
                            locales: []
                        },
                        'CG': {
                            display_name: 'Congo - Brazzaville',
                            code: 'CG',
                            locales: []
                        },
                        'CD': {
                            display_name: 'Congo - Kinshasa',
                            code: 'CD',
                            locales: ['ln_CD', 'ln_CD']
                        },
                        'CK': {
                            display_name: 'Cook Islands',
                            code: 'CK',
                            locales: []
                        },
                        'CR': {
                            display_name: 'Costa Rica',
                            code: 'CR',
                            locales: ['es_CR', 'es_CR']
                        },
                        'CI': {
                            display_name: 'C\u00f4te d\u2019Ivoire',
                            code: 'CI',
                            locales: []
                        },
                        'HR': {
                            display_name: 'Croatia',
                            code: 'HR',
                            locales: ['hr_HR', 'hr_HR']
                        },
                        'CU': {
                            display_name: 'Cuba',
                            code: 'CU',
                            locales: ['es_CU', 'es_CU']
                        },
                        'CW': {
                            display_name: 'Cura\u00e7ao',
                            code: 'CW',
                            locales: []
                        },
                        'CY': {
                            display_name: 'Cyprus',
                            code: 'CY',
                            locales: ['el_CY', 'el_CY', 'tr_CY', 'tr_CY', 'tr_CY']
                        },
                        'CZ': {
                            display_name: 'Czechia',
                            code: 'CZ',
                            locales: ['cs_CZ']
                        },
                        'DK': {
                            display_name: 'Denmark',
                            code: 'DK',
                            locales: ['da_DK', 'da_DK']
                        },
                        'DJ': {
                            display_name: 'Djibouti',
                            code: 'DJ',
                            locales: ['aa_DJ', 'aa_DJ', 'so_DJ', 'so_DJ']
                        },
                        'DM': {
                            display_name: 'Dominica',
                            code: 'DM',
                            locales: []
                        },
                        'DO': {
                            display_name: 'Dominican Republic',
                            code: 'DO',
                            locales: ['es_DO', 'es_DO']
                        },
                        'EC': {
                            display_name: 'Ecuador',
                            code: 'EC',
                            locales: ['es_EC', 'es_EC']
                        },
                        'EG': {
                            display_name: 'Egypt',
                            code: 'EG',
                            locales: ['ar_EG', 'ar_EG']
                        },
                        'SV': {
                            display_name: 'El Salvador',
                            code: 'SV',
                            locales: ['es_SV', 'es_SV']
                        },
                        'GQ': {
                            display_name: 'Equatorial Guinea',
                            code: 'GQ',
                            locales: []
                        },
                        'ER': {
                            display_name: 'Eritrea',
                            code: 'ER',
                            locales: ['aa_ER', 'aa_ER', 'byn_ER', 'byn_ER', 'gez_ER', 'gez_ER', 'ti_ER', 'ti_ER', 'tig_ER', 'tig_ER']
                        },
                        'EE': {
                            display_name: 'Estonia',
                            code: 'EE',
                            locales: ['et_EE']
                        },
                        'SZ': {
                            display_name: 'Eswatini',
                            code: 'SZ',
                            locales: []
                        },
                        'ET': {
                            display_name: 'Ethiopia',
                            code: 'ET',
                            locales: ['aa_ET', 'aa_ET', 'am_ET', 'am_ET', 'gez_ET', 'gez_ET', 'om_ET', 'om_ET', 'sid_ET', 'sid_ET', 'so_ET', 'so_ET', 'ti_ET', 'ti_ET', 'wal_ET', 'wal_ET']
                        },
                        'FK': {
                            display_name: 'Falkland Islands',
                            code: 'FK',
                            locales: []
                        },
                        'FO': {
                            display_name: 'Faroe Islands',
                            code: 'FO',
                            locales: ['fo_FO']
                        },
                        'FJ': {
                            display_name: 'Fiji',
                            code: 'FJ',
                            locales: []
                        },
                        'FI': {
                            display_name: 'Finland',
                            code: 'FI',
                            locales: ['fi_FI', 'fi_FI', 'sv_FI', 'sv_FI']
                        },
                        'FR': {
                            display_name: 'France',
                            code: 'FR',
                            locales: ['br_FR', 'ca_FR', 'eu_FR', 'fr_FR', 'fr_FR', 'fr_FR', 'ia_FR', 'ia_FR', 'oc_FR']
                        },
                        'GF': {
                            display_name: 'French Guiana',
                            code: 'GF',
                            locales: []
                        },
                        'PF': {
                            display_name: 'French Polynesia',
                            code: 'PF',
                            locales: []
                        },
                        'TF': {
                            display_name: 'French Southern Territories',
                            code: 'TF',
                            locales: []
                        },
                        'GA': {
                            display_name: 'Gabon',
                            code: 'GA',
                            locales: []
                        },
                        'GM': {
                            display_name: 'Gambia',
                            code: 'GM',
                            locales: []
                        },
                        'GE': {
                            display_name: 'Georgia',
                            code: 'GE',
                            locales: ['ka_GE']
                        },
                        'DE': {
                            display_name: 'Germany',
                            code: 'DE',
                            locales: ['de_DE', 'de_DE', 'de_DE', 'fy_DE', 'fy_DE', 'hsb_DE', 'nds_DE', 'nds_DE']
                        },
                        'GH': {
                            display_name: 'Ghana',
                            code: 'GH',
                            locales: ['ak_GH', 'ak_GH']
                        },
                        'GI': {
                            display_name: 'Gibraltar',
                            code: 'GI',
                            locales: []
                        },
                        'GR': {
                            display_name: 'Greece',
                            code: 'GR',
                            locales: ['el_GR', 'el_GR']
                        },
                        'GL': {
                            display_name: 'Greenland',
                            code: 'GL',
                            locales: ['kl_GL']
                        },
                        'GD': {
                            display_name: 'Grenada',
                            code: 'GD',
                            locales: []
                        },
                        'GP': {
                            display_name: 'Guadeloupe',
                            code: 'GP',
                            locales: []
                        },
                        'GU': {
                            display_name: 'Guam',
                            code: 'GU',
                            locales: []
                        },
                        'GT': {
                            display_name: 'Guatemala',
                            code: 'GT',
                            locales: ['es_GT', 'es_GT']
                        },
                        'GG': {
                            display_name: 'Guernsey',
                            code: 'GG',
                            locales: []
                        },
                        'GN': {
                            display_name: 'Guinea',
                            code: 'GN',
                            locales: []
                        },
                        'GW': {
                            display_name: 'Guinea-Bissau',
                            code: 'GW',
                            locales: []
                        },
                        'GY': {
                            display_name: 'Guyana',
                            code: 'GY',
                            locales: []
                        },
                        'HT': {
                            display_name: 'Haiti',
                            code: 'HT',
                            locales: ['ht_HT', 'ht_HT']
                        },
                        'HM': {
                            display_name: 'Heard & McDonald Islands',
                            code: 'HM',
                            locales: []
                        },
                        'HN': {
                            display_name: 'Honduras',
                            code: 'HN',
                            locales: ['es_HN', 'es_HN']
                        },
                        'HK': {
                            display_name: 'Hong Kong',
                            code: 'HK',
                            locales: ['en_HK', 'en_HK', 'zh_HK', 'zh_HK']
                        },
                        'HU': {
                            display_name: 'Hungary',
                            code: 'HU',
                            locales: ['hu_HU', 'hu_HU', 'hu_HU']
                        },
                        'IS': {
                            display_name: 'Iceland',
                            code: 'IS',
                            locales: ['is_IS']
                        },
                        'IN': {
                            display_name: 'India',
                            code: 'IN',
                            locales: ['ar_IN', 'ar_IN', 'as_IN', 'as_IN', 'bn_IN', 'bn_IN', 'bo_IN', 'bo_IN', 'en_IN', 'en_IN', 'gu_IN', 'gu_IN', 'hi_IN', 'hi_IN', 'kn_IN', 'kn_IN', 'kok_IN', 'kok_IN', 'ks_IN', 'ml_IN', 'ml_IN', 'mr_IN', 'mr_IN', 'or_IN', 'or_IN', 'pa_IN', 'pa_IN', 'sa_IN', 'sa_IN', 'sd_IN', 'sd_IN', 'ta_IN', 'ta_IN', 'te_IN', 'te_IN', 'ur_IN', 'ur_IN']
                        },
                        'ID': {
                            display_name: 'Indonesia',
                            code: 'ID',
                            locales: ['id_ID']
                        },
                        'IR': {
                            display_name: 'Iran',
                            code: 'IR',
                            locales: ['az_IR', 'az_IR', 'fa_IR', 'fa_IR']
                        },
                        'IQ': {
                            display_name: 'Iraq',
                            code: 'IQ',
                            locales: ['ar_IQ', 'ar_IQ']
                        },
                        'IE': {
                            display_name: 'Ireland',
                            code: 'IE',
                            locales: ['en_IE', 'en_IE', 'ga_IE', 'ga_IE']
                        },
                        'IM': {
                            display_name: 'Isle of Man',
                            code: 'IM',
                            locales: []
                        },
                        'IL': {
                            display_name: 'Israel',
                            code: 'IL',
                            locales: ['en_IL', 'en_IL', 'he_IL']
                        },
                        'IT': {
                            display_name: 'Italy',
                            code: 'IT',
                            locales: ['ca_IT', 'de_IT', 'de_IT', 'de_IT', 'it_IT', 'it_IT', 'it_IT', 'sc_IT', 'sc_IT']
                        },
                        'JM': {
                            display_name: 'Jamaica',
                            code: 'JM',
                            locales: []
                        },
                        'JP': {
                            display_name: 'Japan',
                            code: 'JP',
                            locales: ['ja_JP']
                        },
                        'JE': {
                            display_name: 'Jersey',
                            code: 'JE',
                            locales: []
                        },
                        'JO': {
                            display_name: 'Jordan',
                            code: 'JO',
                            locales: ['ar_JO', 'ar_JO']
                        },
                        'KZ': {
                            display_name: 'Kazakhstan',
                            code: 'KZ',
                            locales: ['kk_KZ']
                        },
                        'KE': {
                            display_name: 'Kenya',
                            code: 'KE',
                            locales: ['om_KE', 'om_KE', 'so_KE', 'so_KE', 'sw_KE', 'sw_KE']
                        },
                        'KI': {
                            display_name: 'Kiribati',
                            code: 'KI',
                            locales: []
                        },
                        'KW': {
                            display_name: 'Kuwait',
                            code: 'KW',
                            locales: ['ar_KW', 'ar_KW']
                        },
                        'KG': {
                            display_name: 'Kyrgyzstan',
                            code: 'KG',
                            locales: ['ky_KG', 'ky_KG']
                        },
                        'LA': {
                            display_name: 'Laos',
                            code: 'LA',
                            locales: ['lo_LA', 'lo_LA']
                        },
                        'LV': {
                            display_name: 'Latvia',
                            code: 'LV',
                            locales: ['lv_LV']
                        },
                        'LB': {
                            display_name: 'Lebanon',
                            code: 'LB',
                            locales: ['ar_LB', 'ar_LB']
                        },
                        'LS': {
                            display_name: 'Lesotho',
                            code: 'LS',
                            locales: []
                        },
                        'LR': {
                            display_name: 'Liberia',
                            code: 'LR',
                            locales: []
                        },
                        'LY': {
                            display_name: 'Libya',
                            code: 'LY',
                            locales: ['ar_LY', 'ar_LY']
                        },
                        'LI': {
                            display_name: 'Liechtenstein',
                            code: 'LI',
                            locales: ['de_LI']
                        },
                        'LT': {
                            display_name: 'Lithuania',
                            code: 'LT',
                            locales: ['lt_LT']
                        },
                        'LU': {
                            display_name: 'Luxembourg',
                            code: 'LU',
                            locales: ['de_LU', 'de_LU', 'de_LU', 'fr_LU', 'fr_LU', 'fr_LU', 'lb_LU', 'lb_LU']
                        },
                        'MO': {
                            display_name: 'Macau',
                            code: 'MO',
                            locales: []
                        },
                        'MG': {
                            display_name: 'Madagascar',
                            code: 'MG',
                            locales: ['mg_MG']
                        },
                        'MW': {
                            display_name: 'Malawi',
                            code: 'MW',
                            locales: []
                        },
                        'MY': {
                            display_name: 'Malaysia',
                            code: 'MY',
                            locales: ['ms_MY', 'ms_MY']
                        },
                        'MV': {
                            display_name: 'Maldives',
                            code: 'MV',
                            locales: ['dv_MV', 'dv_MV']
                        },
                        'ML': {
                            display_name: 'Mali',
                            code: 'ML',
                            locales: []
                        },
                        'MT': {
                            display_name: 'Malta',
                            code: 'MT',
                            locales: ['mt_MT']
                        },
                        'MH': {
                            display_name: 'Marshall Islands',
                            code: 'MH',
                            locales: []
                        },
                        'MQ': {
                            display_name: 'Martinique',
                            code: 'MQ',
                            locales: []
                        },
                        'MR': {
                            display_name: 'Mauritania',
                            code: 'MR',
                            locales: []
                        },
                        'MU': {
                            display_name: 'Mauritius',
                            code: 'MU',
                            locales: []
                        },
                        'YT': {
                            display_name: 'Mayotte',
                            code: 'YT',
                            locales: []
                        },
                        'MX': {
                            display_name: 'Mexico',
                            code: 'MX',
                            locales: ['es_MX', 'es_MX']
                        },
                        'FM': {
                            display_name: 'Micronesia',
                            code: 'FM',
                            locales: []
                        },
                        'MD': {
                            display_name: 'Moldova',
                            code: 'MD',
                            locales: []
                        },
                        'MC': {
                            display_name: 'Monaco',
                            code: 'MC',
                            locales: []
                        },
                        'MN': {
                            display_name: 'Mongolia',
                            code: 'MN',
                            locales: ['mn_MN', 'mn_MN']
                        },
                        'ME': {
                            display_name: 'Montenegro',
                            code: 'ME',
                            locales: ['sr_ME', 'sr_ME']
                        },
                        'MS': {
                            display_name: 'Montserrat',
                            code: 'MS',
                            locales: []
                        },
                        'MA': {
                            display_name: 'Morocco',
                            code: 'MA',
                            locales: ['ar_MA', 'ar_MA']
                        },
                        'MZ': {
                            display_name: 'Mozambique',
                            code: 'MZ',
                            locales: []
                        },
                        'MM': {
                            display_name: 'Myanmar',
                            code: 'MM',
                            locales: ['my_MM', 'my_MM']
                        },
                        'NA': {
                            display_name: 'Namibia',
                            code: 'NA',
                            locales: []
                        },
                        'NR': {
                            display_name: 'Nauru',
                            code: 'NR',
                            locales: []
                        },
                        'NP': {
                            display_name: 'Nepal',
                            code: 'NP',
                            locales: ['ne_NP', 'ne_NP']
                        },
                        'NL': {
                            display_name: 'Netherlands',
                            code: 'NL',
                            locales: ['fy_NL', 'fy_NL', 'li_NL', 'li_NL', 'nds_NL', 'nds_NL', 'nl_NL', 'nl_NL']
                        },
                        'NC': {
                            display_name: 'New Caledonia',
                            code: 'NC',
                            locales: []
                        },
                        'NZ': {
                            display_name: 'New Zealand',
                            code: 'NZ',
                            locales: ['en_NZ', 'en_NZ', 'mi_NZ']
                        },
                        'NI': {
                            display_name: 'Nicaragua',
                            code: 'NI',
                            locales: ['es_NI', 'es_NI']
                        },
                        'NE': {
                            display_name: 'Niger',
                            code: 'NE',
                            locales: []
                        },
                        'NG': {
                            display_name: 'Nigeria',
                            code: 'NG',
                            locales: ['en_NG', 'en_NG', 'ha_NG', 'ha_NG', 'ig_NG', 'ig_NG', 'yo_NG', 'yo_NG']
                        },
                        'NU': {
                            display_name: 'Niue',
                            code: 'NU',
                            locales: []
                        },
                        'NF': {
                            display_name: 'Norfolk Island',
                            code: 'NF',
                            locales: []
                        },
                        'KP': {
                            display_name: 'North Korea',
                            code: 'KP',
                            locales: []
                        },
                        'MK': {
                            display_name: 'North Macedonia',
                            code: 'MK',
                            locales: ['mk_MK', 'sq_MK', 'sq_MK']
                        },
                        'MP': {
                            display_name: 'Northern Mariana Islands',
                            code: 'MP',
                            locales: []
                        },
                        'NO': {
                            display_name: 'Norway',
                            code: 'NO',
                            locales: ['nb_NO', 'nn_NO', 'se_NO', 'se_NO']
                        },
                        'OM': {
                            display_name: 'Oman',
                            code: 'OM',
                            locales: ['ar_OM', 'ar_OM']
                        },
                        'PK': {
                            display_name: 'Pakistan',
                            code: 'PK',
                            locales: ['pa_PK', 'pa_PK', 'sd_PK', 'sd_PK', 'ur_PK', 'ur_PK']
                        },
                        'PW': {
                            display_name: 'Palau',
                            code: 'PW',
                            locales: []
                        },
                        'PS': {
                            display_name: 'Palestine',
                            code: 'PS',
                            locales: []
                        },
                        'PA': {
                            display_name: 'Panama',
                            code: 'PA',
                            locales: ['es_PA', 'es_PA']
                        },
                        'PG': {
                            display_name: 'Papua New Guinea',
                            code: 'PG',
                            locales: []
                        },
                        'PY': {
                            display_name: 'Paraguay',
                            code: 'PY',
                            locales: ['es_PY', 'es_PY']
                        },
                        'PE': {
                            display_name: 'Peru',
                            code: 'PE',
                            locales: ['es_PE', 'es_PE']
                        },
                        'PH': {
                            display_name: 'Philippines',
                            code: 'PH',
                            locales: ['en_PH', 'en_PH', 'tl_PH']
                        },
                        'PN': {
                            display_name: 'Pitcairn Islands',
                            code: 'PN',
                            locales: []
                        },
                        'PL': {
                            display_name: 'Poland',
                            code: 'PL',
                            locales: ['pl_PL']
                        },
                        'PT': {
                            display_name: 'Portugal',
                            code: 'PT',
                            locales: ['pt_PT', 'pt_PT']
                        },
                        'PR': {
                            display_name: 'Puerto Rico',
                            code: 'PR',
                            locales: ['es_PR', 'es_PR']
                        },
                        'QA': {
                            display_name: 'Qatar',
                            code: 'QA',
                            locales: ['ar_QA', 'ar_QA']
                        },
                        'RE': {
                            display_name: 'R\u00e9union',
                            code: 'RE',
                            locales: []
                        },
                        'RO': {
                            display_name: 'Romania',
                            code: 'RO',
                            locales: ['ro_RO']
                        },
                        'RU': {
                            display_name: 'Russia',
                            code: 'RU',
                            locales: ['ce_RU', 'ce_RU', 'cv_RU', 'cv_RU', 'os_RU', 'os_RU', 'ru_RU', 'ru_RU', 'tt_RU', 'tt_RU', 'tt_RU']
                        },
                        'RW': {
                            display_name: 'Rwanda',
                            code: 'RW',
                            locales: ['rw_RW', 'rw_RW']
                        },
                        'WS': {
                            display_name: 'Samoa',
                            code: 'WS',
                            locales: ['sm_WS', 'sm_WS']
                        },
                        'SM': {
                            display_name: 'San Marino',
                            code: 'SM',
                            locales: []
                        },
                        'ST': {
                            display_name: 'S\u00e3o Tom\u00e9 & Pr\u00edncipe',
                            code: 'ST',
                            locales: []
                        },
                        'SA': {
                            display_name: 'Saudi Arabia',
                            code: 'SA',
                            locales: ['ar_SA', 'ar_SA']
                        },
                        'SN': {
                            display_name: 'Senegal',
                            code: 'SN',
                            locales: ['ff_SN', 'ff_SN', 'wo_SN', 'wo_SN']
                        },
                        'RS': {
                            display_name: 'Serbia',
                            code: 'RS',
                            locales: ['sr_RS', 'sr_RS', 'sr_RS']
                        },
                        'SC': {
                            display_name: 'Seychelles',
                            code: 'SC',
                            locales: ['en_SC']
                        },
                        'SL': {
                            display_name: 'Sierra Leone',
                            code: 'SL',
                            locales: []
                        },
                        'SG': {
                            display_name: 'Singapore',
                            code: 'SG',
                            locales: ['en_SG', 'en_SG', 'zh_SG', 'zh_SG']
                        },
                        'SX': {
                            display_name: 'Sint Maarten',
                            code: 'SX',
                            locales: []
                        },
                        'SK': {
                            display_name: 'Slovakia',
                            code: 'SK',
                            locales: ['sk_SK']
                        },
                        'SI': {
                            display_name: 'Slovenia',
                            code: 'SI',
                            locales: []
                        },
                        'SB': {
                            display_name: 'Solomon Islands',
                            code: 'SB',
                            locales: []
                        },
                        'SO': {
                            display_name: 'Somalia',
                            code: 'SO',
                            locales: ['so_SO', 'so_SO']
                        },
                        'ZA': {
                            display_name: 'South Africa',
                            code: 'ZA',
                            locales: ['af_ZA', 'en_ZA', 'en_ZA', 'nr_ZA', 'nr_ZA', 'ss_ZA', 'ss_ZA', 'st_ZA', 'tn_ZA', 'tn_ZA', 'ts_ZA', 'ts_ZA', 've_ZA', 've_ZA', 'xh_ZA', 'zu_ZA']
                        },
                        'GS': {
                            display_name: 'South Georgia & South Sandwich Islands',
                            code: 'GS',
                            locales: []
                        },
                        'KR': {
                            display_name: 'South Korea',
                            code: 'KR',
                            locales: ['ko_KR']
                        },
                        'SS': {
                            display_name: 'South Sudan',
                            code: 'SS',
                            locales: []
                        },
                        'ES': {
                            display_name: 'Spain',
                            code: 'ES',
                            locales: ['an_ES', 'ca_ES', 'ca_ES', 'es_ES', 'es_ES', 'eu_ES', 'gl_ES']
                        },
                        'LK': {
                            display_name: 'Sri Lanka',
                            code: 'LK',
                            locales: ['si_LK', 'si_LK']
                        },
                        'BL': {
                            display_name: 'St. Barth\u00e9lemy',
                            code: 'BL',
                            locales: []
                        },
                        'SH': {
                            display_name: 'St. Helena',
                            code: 'SH',
                            locales: []
                        },
                        'KN': {
                            display_name: 'St. Kitts & Nevis',
                            code: 'KN',
                            locales: []
                        },
                        'LC': {
                            display_name: 'St. Lucia',
                            code: 'LC',
                            locales: []
                        },
                        'MF': {
                            display_name: 'St. Martin',
                            code: 'MF',
                            locales: []
                        },
                        'PM': {
                            display_name: 'St. Pierre & Miquelon',
                            code: 'PM',
                            locales: []
                        },
                        'VC': {
                            display_name: 'St. Vincent & Grenadines',
                            code: 'VC',
                            locales: []
                        },
                        'SD': {
                            display_name: 'Sudan',
                            code: 'SD',
                            locales: ['ar_SD', 'ar_SD']
                        },
                        'SR': {
                            display_name: 'Suriname',
                            code: 'SR',
                            locales: []
                        },
                        'SJ': {
                            display_name: 'Svalbard & Jan Mayen',
                            code: 'SJ',
                            locales: []
                        },
                        'SE': {
                            display_name: 'Sweden',
                            code: 'SE',
                            locales: ['sv_SE', 'sv_SE']
                        },
                        'CH': {
                            display_name: 'Switzerland',
                            code: 'CH',
                            locales: ['de_CH', 'de_CH', 'de_CH', 'fr_CH', 'fr_CH', 'fr_CH', 'it_CH', 'it_CH', 'it_CH']
                        },
                        'SY': {
                            display_name: 'Syria',
                            code: 'SY',
                            locales: ['ar_SY', 'ar_SY']
                        },
                        'TW': {
                            display_name: 'Taiwan',
                            code: 'TW',
                            locales: ['zh_TW', 'zh_TW']
                        },
                        'TJ': {
                            display_name: 'Tajikistan',
                            code: 'TJ',
                            locales: ['tg_TJ']
                        },
                        'TZ': {
                            display_name: 'Tanzania',
                            code: 'TZ',
                            locales: ['sw_TZ', 'sw_TZ']
                        },
                        'TH': {
                            display_name: 'Thailand',
                            code: 'TH',
                            locales: ['th_TH']
                        },
                        'TL': {
                            display_name: 'Timor-Leste',
                            code: 'TL',
                            locales: []
                        },
                        'TG': {
                            display_name: 'Togo',
                            code: 'TG',
                            locales: []
                        },
                        'TK': {
                            display_name: 'Tokelau',
                            code: 'TK',
                            locales: []
                        },
                        'TO': {
                            display_name: 'Tonga',
                            code: 'TO',
                            locales: ['to_TO', 'to_TO']
                        },
                        'TT': {
                            display_name: 'Trinidad & Tobago',
                            code: 'TT',
                            locales: []
                        },
                        'TN': {
                            display_name: 'Tunisia',
                            code: 'TN',
                            locales: ['ar_TN', 'ar_TN']
                        },
                        'TR': {
                            display_name: 'Turkey',
                            code: 'TR',
                            locales: ['ku_TR', 'tr_TR', 'tr_TR', 'tr_TR']
                        },
                        'TM': {
                            display_name: 'Turkmenistan',
                            code: 'TM',
                            locales: ['tk_TM', 'tk_TM']
                        },
                        'TC': {
                            display_name: 'Turks & Caicos Islands',
                            code: 'TC',
                            locales: []
                        },
                        'TV': {
                            display_name: 'Tuvalu',
                            code: 'TV',
                            locales: []
                        },
                        'UM': {
                            display_name: 'U.S. Outlying Islands',
                            code: 'UM',
                            locales: []
                        },
                        'VI': {
                            display_name: 'U.S. Virgin Islands',
                            code: 'VI',
                            locales: []
                        },
                        'UG': {
                            display_name: 'Uganda',
                            code: 'UG',
                            locales: ['lg_UG']
                        },
                        'GB': {
                            display_name: 'UK',
                            code: 'GB',
                            locales: ['cy_GB', 'cy_GB', 'en_GB', 'en_GB', 'gd_GB', 'gv_GB', 'kw_GB']
                        },
                        'UA': {
                            display_name: 'Ukraine',
                            code: 'UA',
                            locales: ['ru_UA', 'ru_UA', 'uk_UA']
                        },
                        'AE': {
                            display_name: 'United Arab Emirates',
                            code: 'AE',
                            locales: ['ar_AE', 'ar_AE']
                        },
                        'UY': {
                            display_name: 'Uruguay',
                            code: 'UY',
                            locales: ['es_UY', 'es_UY']
                        },
                        'US': {
                            display_name: 'US',
                            code: 'US',
                            locales: ['en_US', 'en_US', 'en_US', 'es_US', 'es_US', 'yi_US']
                        },
                        'UZ': {
                            display_name: 'Uzbekistan',
                            code: 'UZ',
                            locales: ['uz_UZ', 'uz_UZ']
                        },
                        'VU': {
                            display_name: 'Vanuatu',
                            code: 'VU',
                            locales: ['bi_VU', 'bi_VU']
                        },
                        'VA': {
                            display_name: 'Vatican City',
                            code: 'VA',
                            locales: []
                        },
                        'VE': {
                            display_name: 'Venezuela',
                            code: 'VE',
                            locales: ['es_VE', 'es_VE']
                        },
                        'VN': {
                            display_name: 'Vietnam',
                            code: 'VN',
                            locales: ['vi_VN', 'vi_VN']
                        },
                        'WF': {
                            display_name: 'Wallis & Futuna',
                            code: 'WF',
                            locales: []
                        },
                        'EH': {
                            display_name: 'Western Sahara',
                            code: 'EH',
                            locales: []
                        },
                        'YE': {
                            display_name: 'Yemen',
                            code: 'YE',
                            locales: ['ar_YE', 'ar_YE']
                        },
                        'ZM': {
                            display_name: 'Zambia',
                            code: 'ZM',
                            locales: ['en_ZM', 'en_ZM']
                        },
                        'ZW': {
                            display_name: 'Zimbabwe',
                            code: 'ZW',
                            locales: ['en_ZW', 'en_ZW']
                        }
                    },
                    enumerable: false
                }
            });
            return Locales;
        };
    }).name;
